import React from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core';

import Content from './PrivacyPolicyContent.mdx';
import Copyright from '€components/Copright';

const useStyles = makeStyles(theme => ({
    root: {
        '& ul': {
            paddingLeft: '1.6rem',
        },
        '& li:not(#table-of-contents + ul li)': {
            paddingLeft: '1.6rem',
            '&::marker': {
                color: theme.palette.primary.main,
                content: '"\\2714"',
            },
        },
        '& #table-of-contents + ul': {
            listStyleType: 'none',
            paddingLeft: 0,
            '& a': {
                textDecoration: 'none',
                color: theme.palette.text.primary,
            },
            '& a:hover': {
                color: theme.palette.primary.main,
            },
            '& a:visited': {
                color: theme.palette.text.primary,
            },
        },
    },
}));

const PrivacyPolicy: React.FunctionComponent = () => {
    const classes = useStyles();
    return (
        <Box>
            <Box mb={3}>
                <Typography variant="subtitle1" color="textPrimary">
                    About Us
                </Typography>
            </Box>
            <Box mb={3}>
                <Typography variant="h1" color="textPrimary">
                    Privacy Policy
                </Typography>
            </Box>
            <Box className={classes.root}>
                <Content />
                <Copyright />
            </Box>
        </Box>
    );
};

export default PrivacyPolicy;
